module.exports = __webpack_public_path__ + "img/w13-b2.81d8b29c.jpg";